<div class="layout-column threepl-supply-account-panel" appBringozIdGenerator="threepl-supply-account-panel">
  <div class="layout-row layout-align-start-center padding-10 gap-5">
    <bz-search-input class="flex"
                     appBringozIdGenerator="threepl-supply-account-search-input"
                     [placeholder]="(data.placeholder || 'Search Carriers') | translate"
                     [debounceMs]="debounceMs"
                     (valueChange)="onSearch($event)">
    </bz-search-input>
    <bz-button variant="tertiary"
               appBringozIdGenerator="threepl-supply-account-reset-button"
               (clicked)="onReset()">
      {{ 'Reset' | translate }}
    </bz-button>
  </div>

  <bz-radio-group class="flex threepl-supply-account-list"
                  appBringozIdGenerator="threepl-supply-account-radio-group"
                  [ariaLabel]="'Account' | translate"
                  [value]="data.selectedId ?? null"
                  (valueChange)="onSelect($event)">
    <bz-table uniqueId="threepl-supply-accounts"
              appBringozIdGenerator="threepl-supply-account-table"
              [items]="accounts()"
              [isLoading]="loading()"
              [rowHeight]="48"
              [headerHeight]="0"
              [resizable]="false"
              (fetchNext)="onFetchNext()">
      <ng-template bzTableRow let-account>
        <div class="tr">
          <div class="td col-account">
            <bz-radio appBringozIdGenerator="threepl-supply-account-option" [value]="account.id">
              <span class="layout-column">
                <span class="br-body-2">{{ account.name }}</span>
                @if (account.externalId) {
                  <span class="br-caption-2">{{ account.externalId }}</span>
                }
              </span>
            </bz-radio>
          </div>
        </div>
      </ng-template>
      <bz-empty-state bzTableEmptyState
                      [title]="'No Accounts Found' | translate"
                      image="assets/images/empty_state/empty_state_accounts.png">
      </bz-empty-state>
    </bz-table>
  </bz-radio-group>
</div>
